// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectCustom_container__BTmQF.SelectCustom_container__BTmQF {
  width: 100%;
}

.SelectCustom_container__BTmQF.SelectCustom_container__BTmQF.SelectCustom_size-sm__kyxeF {
  height: 40px;
}

.SelectCustom_container__BTmQF.SelectCustom_container__BTmQF.SelectCustom_size-md__Z8dgi {
  height: 48px;
}

.SelectCustom_container__BTmQF.SelectCustom_container__BTmQF.SelectCustom_size-xl__SfT\\+t {
  max-height: 60px;
  height: 100%;
}

.SelectCustom_container__BTmQF.SelectCustom_container__BTmQF.SelectCustom_size-dm__Dqgak {
  height: auto;
}

.SelectCustom_control__Y3BT8.SelectCustom_control__Y3BT8 {
  padding: 0 12px;
  height: auto;
  background: white;
}

.SelectCustom_control__Y3BT8.SelectCustom_control__Y3BT8.SelectCustom_size-sm__kyxeF {
  height: 40px;
}

.SelectCustom_control__Y3BT8.SelectCustom_control__Y3BT8.SelectCustom_size-md__Z8dgi {
  height: 48px;
  padding: 10px;
}

.SelectCustom_control__Y3BT8.SelectCustom_control__Y3BT8.SelectCustom_size-xl__SfT\\+t {
  height: 60px;
  height: auto;
}

.SelectCustom_control__Y3BT8.SelectCustom_control__Y3BT8.SelectCustom_border__a5Yta {
  border: 1px solid #a3c0d2 !important;
  box-shadow: none !important;
  border-radius: 10px;
}

.SelectCustom_control__Y3BT8.SelectCustom_control__Y3BT8.SelectCustom_withoutStyle__qmzxr {
  border: 0px solid rgb(255, 255, 255);
  box-shadow: none;
  position: relative; /* Установка позиционирования, чтобы было возможно позиционировать псевдоэлемент */
}

.SelectCustom_control__Y3BT8.SelectCustom_control__Y3BT8.SelectCustom_border__a5Yta:hover {
  border: 1px solid #8ea3b0 !important;
}

.SelectCustom_control__Y3BT8.SelectCustom_control__Y3BT8.SelectCustom_border-focused__RDGDy {
  border: 1px solid #0c6154 !important;
  box-shadow: none !important;
}

.SelectCustom_control__Y3BT8.SelectCustom_control__Y3BT8.SelectCustom_border-disabled__ZGtsG {
  background-color: #fafafa; /* Красный цвет фона при деактивации */
}

.SelectCustom_control__Y3BT8.SelectCustom_control__Y3BT8.SelectCustom_border-error__\\+rFNk {
  border-color: #ed1e1e;
}

.SelectCustom_placeholder__EWcP0.SelectCustom_placeholder__EWcP0 {
  color: #a3c0d2;
  font-weight: 400;
}
.SelectCustom_placeholder__EWcP0.SelectCustom_placeholderred__VoNnS {
  color: #ff716a;
  font-weight: 400;
}

.SelectCustom_placeholder__EWcP0.SelectCustom_placeholder__EWcP0.SelectCustom_size-sm__kyxeF {
  font-size: 14px;
}

.SelectCustom_placeholder__EWcP0.SelectCustom_placeholder__EWcP0.SelectCustom_size-md__Z8dgi {
  font-size: 16px;
}

.SelectCustom_placeholder__EWcP0.SelectCustom_placeholder__EWcP0.SelectCustom_size-xl__SfT\\+t {
  font-size: 14px;
}

.SelectCustom_placeholder__EWcP0.SelectCustom_placeholder__EWcP0.SelectCustom_size-dm__Dqgak {
  font-size: 14px;
}

.SelectCustom_valueContainer__-SIj-.SelectCustom_valueContainer__-SIj-.SelectCustom_size-dm__Dqgak {
  flex-wrap: wrap;
  width: min-content;
  /* padding-top: 4px; */
}

.SelectCustom_valueContainer__-SIj-.SelectCustom_valueContainer__-SIj-.SelectCustom_size-dm__Dqgak input {
  position: absolute;
}

.SelectCustom_valueContainer__-SIj-.SelectCustom_valueContainer__-SIj- {
  overflow: hidden;
  flex-wrap: nowrap;
  padding: 0;
}

.SelectCustom_indicatorSeparator__9J6Bb.SelectCustom_indicatorSeparator__9J6Bb {
  display: none;
}

.SelectCustom_input__B-AK5.SelectCustom_input__B-AK5.SelectCustom_size-sm__kyxeF {
  height: 40px;
  padding-top: 0;
  margin: 0;
}

.SelectCustom_input__B-AK5.SelectCustom_input__B-AK5.SelectCustom_size-dm__Dqgak {
  height: 40px;
  padding-top: 0;
  margin: 0;
}
.SelectCustom_input__B-AK5.SelectCustom_input__B-AK5.SelectCustom_size-xl__SfT\\+t {
  height: 60px;
  padding-top: 0;
  margin: 0;
}

.SelectCustom_indicatorsContainer__FEuzS {
  width: 24px;
  height: 24px;
  display: flex;
}

.SelectCustom_singleValue__vY-0h.SelectCustom_singleValue__vY-0h {
  font-size: 14px;
  font-weight: 500;
  color: #364954;
}

.SelectCustom_option__hCe\\+0.SelectCustom_option__hCe\\+0 {
  border-bottom: 1px solid #d2bba3;
  block-size: fit;
}

.SelectCustom_option__hCe\\+0.SelectCustom_option__hCe\\+0:hover {
  background-color: #e9f0f3;
}

.SelectCustom_option__hCe\\+0.SelectCustom_option__hCe\\+0:last-of-type {
  border-bottom: none;
}

.SelectCustom_option__hCe\\+0.SelectCustom_option__hCe\\+0.SelectCustom_selected__xgBNH {
  background-color: #55bbeb;
}

.SelectCustom_option__hCe\\+0.SelectCustom_option__hCe\\+0.SelectCustom_selected__xgBNH:hover {
  background-color: #65c7f4;
}

.SelectCustom_menu__gQzEG.SelectCustom_menu__gQzEG {
  border: 1px solid #a3c0d2;
  border-radius: 8px;
  overflow: hidden;
  z-index: 2 !important;
}

.SelectCustom_menuList__sPklM.SelectCustom_menuList__sPklM {
  padding: 0;

}

.SelectCustom_menuList__sPklM.SelectCustom_menuList__sPklM:hover {
  background-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/shared/Ui/SelectCustom/SelectCustom.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EAIZ,YAAY;AAHd;;AAMA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB,EAAE,kFAAkF;AACxG;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;AACnE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;AACX;AACA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;;AAEZ;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".container.container {\n  width: 100%;\n}\n\n.container.container.size-sm {\n  height: 40px;\n}\n\n.container.container.size-md {\n  height: 48px;\n}\n\n.container.container.size-xl {\n  max-height: 60px;\n  height: 100%;\n}\n\n.container.container.size-dm {\n  height: auto;\n}\n\n.control.control {\n  padding: 0 12px;\n  height: auto;\n  background: white;\n}\n\n.control.control.size-sm {\n  height: 40px;\n}\n\n.control.control.size-md {\n  height: 48px;\n  padding: 10px;\n}\n\n.control.control.size-xl {\n  height: 60px;\n}\n\n.control.control.size-xl {\n  height: auto;\n}\n\n.control.control.border {\n  border: 1px solid #a3c0d2 !important;\n  box-shadow: none !important;\n  border-radius: 10px;\n}\n\n.control.control.withoutStyle {\n  border: 0px solid rgb(255, 255, 255);\n  box-shadow: none;\n  position: relative; /* Установка позиционирования, чтобы было возможно позиционировать псевдоэлемент */\n}\n\n.control.control.border:hover {\n  border: 1px solid #8ea3b0 !important;\n}\n\n.control.control.border-focused {\n  border: 1px solid #0c6154 !important;\n  box-shadow: none !important;\n}\n\n.control.control.border-disabled {\n  background-color: #fafafa; /* Красный цвет фона при деактивации */\n}\n\n.control.control.border-error {\n  border-color: #ed1e1e;\n}\n\n.placeholder.placeholder {\n  color: #a3c0d2;\n  font-weight: 400;\n}\n.placeholder.placeholderred {\n  color: #ff716a;\n  font-weight: 400;\n}\n\n.placeholder.placeholder.size-sm {\n  font-size: 14px;\n}\n\n.placeholder.placeholder.size-md {\n  font-size: 16px;\n}\n\n.placeholder.placeholder.size-xl {\n  font-size: 14px;\n}\n\n.placeholder.placeholder.size-dm {\n  font-size: 14px;\n}\n\n.valueContainer.valueContainer.size-dm {\n  flex-wrap: wrap;\n  width: min-content;\n  /* padding-top: 4px; */\n}\n\n.valueContainer.valueContainer.size-dm input {\n  position: absolute;\n}\n\n.valueContainer.valueContainer {\n  overflow: hidden;\n  flex-wrap: nowrap;\n  padding: 0;\n}\n\n.indicatorSeparator.indicatorSeparator {\n  display: none;\n}\n\n.input.input.size-sm {\n  height: 40px;\n  padding-top: 0;\n  margin: 0;\n}\n\n.input.input.size-dm {\n  height: 40px;\n  padding-top: 0;\n  margin: 0;\n}\n.input.input.size-xl {\n  height: 60px;\n  padding-top: 0;\n  margin: 0;\n}\n\n.indicatorsContainer {\n  width: 24px;\n  height: 24px;\n  display: flex;\n}\n\n.singleValue.singleValue {\n  font-size: 14px;\n  font-weight: 500;\n  color: #364954;\n}\n\n.option.option {\n  border-bottom: 1px solid #d2bba3;\n  block-size: fit;\n}\n\n.option.option:hover {\n  background-color: #e9f0f3;\n}\n\n.option.option:last-of-type {\n  border-bottom: none;\n}\n\n.option.option.selected {\n  background-color: #55bbeb;\n}\n\n.option.option.selected:hover {\n  background-color: #65c7f4;\n}\n\n.menu.menu {\n  border: 1px solid #a3c0d2;\n  border-radius: 8px;\n  overflow: hidden;\n  z-index: 2 !important;\n}\n\n.menuList.menuList {\n  padding: 0;\n\n}\n\n.menuList.menuList:hover {\n  background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SelectCustom_container__BTmQF`,
	"size-sm": `SelectCustom_size-sm__kyxeF`,
	"size-md": `SelectCustom_size-md__Z8dgi`,
	"size-xl": `SelectCustom_size-xl__SfT+t`,
	"size-dm": `SelectCustom_size-dm__Dqgak`,
	"control": `SelectCustom_control__Y3BT8`,
	"border": `SelectCustom_border__a5Yta`,
	"withoutStyle": `SelectCustom_withoutStyle__qmzxr`,
	"border-focused": `SelectCustom_border-focused__RDGDy`,
	"border-disabled": `SelectCustom_border-disabled__ZGtsG`,
	"border-error": `SelectCustom_border-error__+rFNk`,
	"placeholder": `SelectCustom_placeholder__EWcP0`,
	"placeholderred": `SelectCustom_placeholderred__VoNnS`,
	"valueContainer": `SelectCustom_valueContainer__-SIj-`,
	"indicatorSeparator": `SelectCustom_indicatorSeparator__9J6Bb`,
	"input": `SelectCustom_input__B-AK5`,
	"indicatorsContainer": `SelectCustom_indicatorsContainer__FEuzS`,
	"singleValue": `SelectCustom_singleValue__vY-0h`,
	"option": `SelectCustom_option__hCe+0`,
	"selected": `SelectCustom_selected__xgBNH`,
	"menu": `SelectCustom_menu__gQzEG`,
	"menuList": `SelectCustom_menuList__sPklM`
};
export default ___CSS_LOADER_EXPORT___;
